import $ from 'jquery';

/**
 * Ajax Pagination
 */

export default () => {

  $(document).ready(function() {
        
    $('.projects-list').on('click','.pagination a.page-numbers',function(e) {
        
        e.preventDefault();

        var link = jQuery(this).attr('href');
        
        var prjContainer = '#' + $(this).closest('.projects-list').attr('id');

        var prjFilter = $(this).closest('.projects-wrapper').find('.project-filter');
        var pIndustry = $(prjFilter).children('select.fl-industry').val();
        var pLocation = $(prjFilter).children('select.fl-location').val();

        var paged = link.replace(/\/$/, '').split('/').pop();
        var cPage = $(this).closest('.projects-list').attr('data-page');
                
        $.ajax({
              url : wg_ajax_url.ajaxurl, 
              method : 'post',
              data : {
                  action : 'projects_fetch', 
                  paged : paged,
                  cPage : cPage,
                  pIndustry : pIndustry,
                  pLocation : pLocation,
              },
              beforeSend : function ( xhr ) {
                    $(prjContainer).addClass('preload');
                },
              success : function( response ) {
                $(prjContainer).empty();
                $(prjContainer).append(response);
                $(prjContainer).removeClass('preload');
                $('html,body').animate({
                  scrollTop: $(prjContainer).offset().top - 200
                }, 1000);
              },
              error : function () {
                $("Problem").appendTo(prjContainer);
              }
          });

    });

    // Project Filter
    var projectFilter = $('.project-filter');

    // Industry Changes
    $(projectFilter).on('change', 'select.fl-industry, select.fl-location', function(){

      var prjFilter = $(this).closest('.project-filter');
      var pIndustry = $(prjFilter).children('select.fl-industry').val()
      var pLocation = $(prjFilter).children('select.fl-location').val();

      var prjContainer = '#' + $(this).closest('.projects-wrapper').children('.projects-list').attr('id');

      $.ajax({
        url : wg_ajax_url.ajaxurl, 
        method : 'post',
        data : {
            action :   'projects_filter_fetch', 
            pIndustry : pIndustry,
            pLocation : pLocation,
        },
        beforeSend : function ( xhr ) {
              $(prjContainer).addClass('preload');
          },
        success : function( response ) {
          $(prjContainer).empty();
          $(prjContainer).append(response);
          $(prjContainer).removeClass('preload');
        },
        error : function () {
          $("Problem").appendTo(prjContainer);
        }
    });
    });
});
  
};
